<template>
  <div class="sino-card" v-loading.fullscreen.lock="loading">
    <div class="sion-card-title">
        <div @click="selectTab('underWay')" :class="['title' , active == 'underWay'?'active': '']">进行中<span v-if='active == "underWay"'></span></div>
        <div @click="selectTab('notYet')" :class="['title' , active == 'notYet'?'active': '']">未开始<span v-if='active == "notYet"'></span></div>
        <div @click="selectTab('complete')" :class="['title' , active == 'complete'?'active': '']">已结束<span v-if='active == "complete"'></span></div>
    </div>
    <div class="card-box" v-for="item in activeityList" :key="item.welfareId" @click='openActivity(item)'>
      <div class="card-title">
        <img src="@/images/hd.png" alt srcset>
        <span>{{item.name}}</span>
      </div>
      <div class="card-content">
        <div v-html='item.content' class="content-text">
        </div>
        <div class="content-date">{{item.startTime}} ~ {{item.endTime}}</div>
      </div>
      <div class="card-footer">
        查看详情
        <i class="cubeic-arrow"></i>
        <span v-if="item.type == 2" class="acti-type">报名活动</span>
        <span v-else class="acti-type" style="color:#4F87FB">打卡活动</span>
      </div>
    </div>
    <div v-if="activeityList.length <= 0" class="blank">
      <img src="@/images/404-02.png" alt>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { activityListData,getSignGroup,getUserInformation, delCookie } from "@/common/api";
import { toast } from "@/common/api/api.js";
export default {
  data() {
    return {
      activeityList: [],
      loading: false,
      active:"underWay"
    };
  },
  created() {
    this.getActivityList();
    let id = JSON.parse(window.localStorage.getItem("loginInfo")).id || "";
      getUserInformation({
        id: id
      }).then(res => {
        if (res.code == 200) {
          if (!res.data.status) {
            this.$createDialog({
              type: "alert",
              title: "提示",
              content: "登录失效,请重新登录",
              icon: "cubeic-alert",
              confirmBtn: {
                text: "退出",
                active: true,
                href: "javascript:;"
              },
              onConfirm: () => {
                window.localStorage.clear();
                delCookie("sessionId");
                this.$router.push("/login");
                window.location.reload();
              }
            }).show();
          }
        }
      });
  },
  methods: {
    getActivityList(option) {
      this.loading = true;
      activityListData({
        status: option?option.status : 1,
      }).then(res => {
        if (res.code == 200) {
          res.data.list.forEach(item=>{
            item.content = item.content.replace(new RegExp("&lt;", "g"), "<").replace(new RegExp("&gt;", "g"), ">").replace(new RegExp("&quot;", "g"), "");
          })
          this.activeityList = res.data.list;
          this.loading = false;
        } else {
          toast(this, res.message, "error");
          this.loading = false;
        }
      });
    },
    selectTab(type){
      this.active = type 
      if(type == 'notYet'){//未开始
          this.getActivityList({status:0})
      }else if(type == "complete"){//已结束
          this.getActivityList({status:2})
      }else{//进行中
          this.getActivityList({status:1})
      }
    },
    openActivity(item){
      console.log(item)
      if(item.type != 2){
        getSignGroup({
          id:item.id
        }).then(res=>{
          if(res.code == 200){
            if(res.data.length <= 1){
              this.$router.push({
                path:'/directActivity',
                query:{
                  id:item.id,
                  status:item.status,
                  signGroupId:item.signGroupId || '',
                }
              })
            }else{
              this.$router.replace({
                path:"/activityType",
                query:{
                  id:item.id,
                  status:item.status
                }
              })
            }
          }
        })

      }else{
          this.$router.push({
            path:'/signupActivity',
            query:{
              id:item.id,
              status:item.status
            }
          })
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "personnelManagement") {
      next({ name: "personalCenter" });
    } else {
      next();
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
.sino-card{
  background:#F0F0F4;
}
.acti-type {
  padding:3px 5px;
  background: rgba(233, 244, 244, 1);
  float: right;
  font-weight: bold;
  height: 18px;
  line-height: 18px;
  margin-top: 0.16rem;
  color: rgba(56, 199, 196, 1);
  font-size:11px;
}
</style>